import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import SkipToMainComponent from '@office-start/skip-to-main-component';
import React from 'react';
import { initializeFluentIcons } from '../shared/office-start/initialize-fluent-icons';
import ReactRenderer from '../shared/react/react-renderer';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';

@Directive({ selector: 'skip-to-main' })
export class SkipToMainDirective extends ReactRenderer implements OnInit, OnDestroy {
  private readonly skipToMainContainerElementRef: ElementRef;

  constructor(
    elementRef: ElementRef,
    private readonly capabilitiesService: CapabilitiesService,
    private readonly contextService: ContextService,
    private readonly clientStartupConfigService: ClientStartupConfigService
  ) {
    super(elementRef);
    const containerElement = document.createElement('div');
    containerElement.setAttribute('id', 'SkipToMainContent');
    document.body.insertBefore(containerElement, document.body.firstChild);
    this.skipToMainContainerElementRef = new ElementRef(containerElement);
    initializeFluentIcons(this.capabilitiesService, this.contextService, this.clientStartupConfigService);
  }

  public async ngOnInit() {
    super.ngOnInit();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public async getReactElement() {
    return (
      <OfficeFluentProvider>
        <SkipToMainComponent mainContentElementId='officeHome__wrapper'/>
      </OfficeFluentProvider>
    );
  }

  protected getTargetElementRef(): ElementRef {
    return this.skipToMainContainerElementRef;
  }
}
